import { CwtApiSchema, CwtProp, CwtSchema } from "@cawita/core-front/api";
import { CustomField } from "./custom-field.model";

export enum CustomFieldSetFilterCondition {
    In = 'in',
    NotIn = 'notIn'
}

@CwtSchema()
export class CustomFieldSetFilter extends CwtApiSchema {
    @CwtProp({ ref: CustomField }) dependsOn: CustomField;
    @CwtProp() condition: CustomFieldSetFilterCondition;
    @CwtProp() enumValues: string[];
}